import React, { useContext } from 'react';

import { compose } from 'recompose';

import { withStyles } from '@material-ui/core';

import { DataviewerContext } from 'containers/Dataviewer';

import Block from 'components/Block';

import Layers from '../partials/Layers';

import styles from './styles';

const enhancer = compose(withStyles(styles));

const Step4 = () => {
  const { state } = useContext(DataviewerContext);
  const { layers } = state;
  const { step4: step } = layers;
  return (
    <>
      <Block>
        <Layers data={step} identifier="step4" />
      </Block>
    </>
  );
};

export default enhancer(Step4);
